import React from 'react';

const ErrorMessage = ({ error, onDismiss }) => {
  if (!error) return null;
  const getIcon = (code) => ({ VIDEO_PRIVATE: '🔒', VIDEO_UNAVAILABLE: '🚫', TIMEOUT: '⏱️', NO_SPEECH_DETECTED: '🔇', LIMIT_REACHED: '📊', NETWORK_ERROR: '📡' }[code] || '⚠️');
  return (
    <div style={{ padding: '16px', borderRadius: '14px', background: 'var(--accent-subtle-bg)', border: '1px solid var(--accent-subtle-border)', marginBottom: '20px' }}>
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
        <span style={{ fontSize: '24px' }}>{getIcon(error.code)}</span>
        <div style={{ flex: 1 }}>
          <p style={{ color: 'var(--error)', fontSize: '14px', margin: 0, fontWeight: '500' }}>{error.error || error.message || 'Something went wrong'}</p>
          {error.code && <p style={{ color: 'var(--text-muted)', fontSize: '12px', margin: '4px 0 0 0' }}>Error code: {error.code}</p>}
        </div>
        <button style={{ background: 'none', border: 'none', color: 'var(--text-muted)', fontSize: '20px', cursor: 'pointer' }} onClick={onDismiss}>×</button>
      </div>
    </div>
  );
};

export default ErrorMessage;
